import React from 'react';

const Add = () => {
  return (
    <>
      <svg
        width="25"
        height="26"
        viewBox="0 0 25 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 25.4727C19.1274 25.4727 24.5 20.1001 24.5 13.4727C24.5 6.84524 19.1274 1.47266 12.5 1.47266C5.87258 1.47266 0.5 6.84524 0.5 13.4727C0.5 20.1001 5.87258 25.4727 12.5 25.4727Z"
          stroke="var(--primary-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.35547 13.4727H17.6412"
          stroke="var(--primary-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 8.33008V18.6158"
          stroke="var(--primary-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default Add;
